import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { adminLogout } from "../../api/serviceDeskApi";

const NAV = [
  { to: "/admin", end: true, icon: "bi-speedometer2", label: "Dashboard" },
  { to: "/admin/blogs", icon: "bi-journal-richtext", label: "Blogs" },
  { to: "/admin/blog-categories", icon: "bi-folder2", label: "Blog Categories" },
  { to: "/admin/jobs", icon: "bi-briefcase", label: "Jobs" },
  { to: "/admin/job-categories", icon: "bi-tags", label: "Job Categories" },
  { to: "/admin/applications", icon: "bi-file-earmark-person", label: "Applications" },
  { to: "/admin/contact-inquiries", icon: "bi-envelope-paper", label: "Contact Inquiries" },
  { to: "/admin/sale-inquiries", icon: "bi-currency-rupee", label: "Sale Inquiries" },
  { to: "/admin/aws-activate", icon: "bi-cloud-check", label: "AWS Activate" },
  { to: "/admin/partners", icon: "bi-award", label: "Partners" },
  { to: "/admin/partner-categories", icon: "bi-grid-3x3-gap", label: "Partner Categories" },
  { to: "/admin/service-desk", icon: "bi-headset", label: "Service Desk" },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  const logout = () => {
    adminLogout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <div>
            <strong>Emicron Admin</strong>
            <span>Content &amp; Careers</span>
          </div>
        </div>
        <nav className="admin-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `admin-nav-link${isActive ? " is-active" : ""}`}
            >
              <i className={`bi ${item.icon}`} aria-hidden="true" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-foot">
          <a href="/" className="admin-nav-link" target="_blank" rel="noreferrer">
            <i className="bi bi-box-arrow-up-right" aria-hidden="true" />
            View website
          </a>
          <button type="button" className="admin-nav-link admin-logout" onClick={logout}>
            <i className="bi bi-box-arrow-left" aria-hidden="true" />
            Logout
          </button>
        </div>
      </aside>
      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
}
